import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PublicAuthOverlayProps {
  onDismiss?: () => void;
}

export const PublicAuthOverlay: React.FC<PublicAuthOverlayProps> = ({ onDismiss }) => {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    onDismiss?.();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="relative mx-4 w-full max-w-md rounded-2xl bg-background p-8 shadow-xl border border-border">
        <button
          onClick={handleDismiss}
          className="absolute right-4 top-4 rounded-full p-1 text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
          aria-label="Close"
        >
          <X className="h-5 w-5" />
        </button>

        <div className="flex flex-col items-center text-center gap-4">
          <h2 className="text-xl font-semibold text-foreground">
            Sign in to start learning
          </h2>
          <p className="text-sm text-muted-foreground leading-relaxed max-w-sm">
            Log in or sign up to add your learning materials, talk with an AI tutor, and more.
          </p>

          <div className="flex w-full flex-col gap-3 mt-2">
            <Button
              onClick={() => navigate("/auth/signin")}
              className="w-full h-11 text-base font-medium"
            >
              Sign In
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate("/auth/signup")}
              className="w-full h-11 text-base font-medium"
            >
              Sign Up
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
